var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PenEventName } from "../common/enums";
import { NEO_SMARTPEN_TYPE } from "../common/neopen/INeoSmartpen";
import SmartPenBase from "./SmartPenBase";
import WebViewPenManager from "./WebViewPenManager";
// const NUM_HOVER_POINTERS = 6;
export default class WebViewPen extends SmartPenBase {
    /**
     *
     * @param mac
     * @param customStorage
     */
    constructor(mac, customStorage = null) {
        super(customStorage, undefined, mac);
        /**
         * npm install -D @types/web-bluetooth
         *
         * @return {*}  {BluetoothDevice}
         * @memberof WebViewPen
         */
        this.getBtDevice = () => {
            return this.protocolHandler.getBtDevice();
        };
        this.getMac = () => {
            // return this.getBtDevice().id;
            return this.protocolHandler.getMac();
        };
        /**
         *
         *
         * @return {*}  {Promise<boolean>}
         * @memberof WebViewPen
         */
        this.connect = (requestOnlineDataOnConencted = true) => __awaiter(this, void 0, void 0, function* () {
            return yield WebViewPenManager.getInstance().handleConnectPen(this.mac);
        });
        /**
         *
         *
         * @memberof WebViewPen
         */
        this.disconnect = () => {
            WebViewPenManager.getInstance().handleDisconnectPen(this.mac);
        };
        /**
         *
         *
         * @param {{
         *     timeStamp: number,
         *     penTipMode: number,
         *   }} event
         * @memberof WebViewPen
         */
        // onPenDown(
        //   event: {
        //     timeStamp: number,
        //     penTipMode: number,
        //   }
        // ) {
        //   super.onPenDown(event);
        // }
        /**
         * 펜의 움직임
         *    1) down/up이 있는 경우: DOWN -> INFO -> MOVE -> MOVE -> ... -> UP -> INFO와 같이 나옴
         *    2) hove의 경우: (페이지가 바뀌면) INFO -> HOVER_MOVE -> HOVER_MOVE...
         *
         * pen down 된 후의 page info, 실질적으로 pen_down과 같음
         *
         *
         * @param {{
         *       section: number, owner: number, book: number, page: number,
         *       timeStamp: number,
         *     }} event
         * @param {boolean} hover
         * @memberof WebViewPen
         */
        // onPageInfo(
        //   event: {
        //     timeStamp: number,
        //     section: number, owner: number, book: number, page: number,
        //   },
        //   hover: boolean
        // ) {
        //   super.onPageInfo(event, hover);
        // }
        /**
         * pen down 상태에서 움직임
         *
         *
         * @param {{
         *       x: number,
         *       y: number,
         *       force: number,
         *       timeStamp: number,
         *       timediff: number
         *     }} event
         * @memberof WebViewPen
         */
        // onPenMove(
        //   event: {
        //     timeStamp: number,
        //     x: number, y: number, force: number,
        //     timediff: number
        //   }
        // ) {
        //   super.onPenMove(event);
        // }
        /**
         * hover 상태에서 움직임
         *
         * @param {{
         *       x: number, y: number, force: number,
         *       timeStamp: number, timeDiff: number
         *     }} event
         * @memberof WebViewPen
         */
        // onHoverMove(
        //   event: {
        //     timeStamp: number,
        //     x: number, y: number, force: number,
        //     timeDiff: number
        //   }
        // ) {
        //   super.onHoverMove(event);
        // }
        /**
         * hover 상태에서 페이지 바뀜
         *
         * @param {{
         *     section: number, owner: number, book: number, page: number,
         *     timeStamp: number,
         *   }} event
         * @memberof WebViewPen
         */
        // onHoverPageInfo(event: {
        //   timeStamp: number,
        //   section: number, owner: number, book: number, page: number,
        // }) {
        //   super.onHoverPageInfo(event);
        // }
        /**
         *
         *
         * @param {{ timeStamp: number }} event
         * @memberof WebViewPen
         */
        // onPenUp(event: { timeStamp: number }) {
        //   super.onPenUp(event);
        // }
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof WebViewPen
         */
        // onNcodeError(event: IPenCommEvent) {
        //   super.onNcodeError(event);
        // }
        /**
         * 2021/08/18
         * @param event
         * @returns
         */
        // onPasscodeRequired(event: IPenCommEvent) {
        //   super.onPasscodeRequired(event);
        // }
        /**
         * 2021/08/18
         * @param passcode
         */
        // sendPasscode(passcode: string) {
        //   super.sendPasscode(passcode);
        // }
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof WebViewPen
         */
        this.onConnected = (event) => {
            console.log("WebViewPen CONNECTED");
            this.mac = event.mac;
            this.connected = true;
            console.log(`Connected: ${this.mac}`);
            this.manager.add(this);
            // this.manager.onConnected({ pen: this, event });
            this.dispatcher.dispatch(PenEventName.ON_CONNECTED, {
                inputType: this.inputType,
                pen: this,
                mac: event.mac,
                event: event
            });
        };
        this.inputType = WebViewPen.getInputType();
        this.connected = false;
        this.protocolHandler = null;
        this.webBluetoothId = WebViewPen.generateWebBluetoothId();
    }
    static generateWebBluetoothId() {
        const webBluetoothId = "sdk-pen";
        return webBluetoothId;
    }
    static getInputType() {
        return NEO_SMARTPEN_TYPE.SDK_PEN;
    }
}
//# sourceMappingURL=WebViewPen.js.map